import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
//import Login from "./pages/login"; // Import the Login component
//import CreateUser from './components/create_user'; // Import the Create_user component
//import DetailUser from './pages/modules/admin_users/detail_user'; // Import the Detail_user component
//import ListUsers from "./pages/modules/admin_users/list_users"; // Import the List_users component
import App from "./App"; // Import the App component
import CssBaseline from "@mui/material/CssBaseline";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { UserCountryProvider } from "./context/UserCountryContext";

const clientId = "279617664043-rhik77roo52kob1tfe1j80da82m41pqe.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <CssBaseline />
    <GoogleOAuthProvider clientId={clientId}>
      <UserCountryProvider>
        <App />
      </UserCountryProvider>
    </GoogleOAuthProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
